import styled from 'styled-components';

export const TermsMessage = styled('div')`
  width: 100%;
  padding: 8px;
  background-color: #e6e6e6;
  border-radius: 4px;

  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  margin: 16px 0;
  color: #333333;

  a {
    color: #333333;
    text-decoration: none;
  }
`;

export const RecaptchaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 16px;
`;

export const IdentityTypeSelector = styled.div`
  display: flex;
  gap: 16px;
  margin: 0 0 16px;
`;

export const CheckboxWrapper = styled.div`
  margin: 16px 0;
`;
